angular.module('SpidApp')

.factory('Agency',
        ['Currency',
function (Currency) {
	var Agency = function (params) {
		params = params || {}
		
		this.id       		= params.id;
		this.name     		= params.name;
		this.code_regate	= params.code_regate;
		this.mail     		= params.mail;
		this.currency 		= new Currency(params.currency);
	};

	Agency.prototype.getName = function () {
		return this.name;
	};

	Agency.prototype.getCurrency = function () {
		return this.currency;
	};
	
	Agency.prototype.getCodeRegate = function () {
		return this.code_regate;
	};
	
	Agency.prototype.getMail = function () {
		return this.mail;
	};

	return Agency;
}]);